import React from 'react';
import { ChartSign } from '../../../../../../types';
import { useChartStoreFieldActions, useChartStoreFieldConfig } from '../../../../../../context';
import FieldRowBase from '../../../fieldRowBase';

type Props = {
    sourceId: number;
    fieldId: string;
};

const FieldRow = React.memo(function FieldRow({ sourceId, fieldId }: Props) {
    const fieldConfig = useChartStoreFieldConfig(sourceId, fieldId);
    const { changeFieldChartSign, toggleFieldChartType, toggleFieldAnnotation, toggleFieldSeparateAxis } = useChartStoreFieldActions();

    if (!fieldConfig) {
        return null;
    }

    const { chartSign, seriesType, annotationsEnabled, separateAxis, label } = fieldConfig;

    return (
        <FieldRowBase
            label={label}
            chartSign={chartSign}
            seriesType={seriesType}
            annotationsEnabled={annotationsEnabled}
            separateAxis={separateAxis}
            onToggleSelection={() =>
                changeFieldChartSign(sourceId, fieldId, chartSign !== ChartSign.OFF ? ChartSign.OFF : ChartSign.POSITIVE)
            }
            onToggleSign={() =>
                changeFieldChartSign(sourceId, fieldId, chartSign === ChartSign.POSITIVE ? ChartSign.NEGATIVE : ChartSign.POSITIVE)
            }
            onToggleChartType={() => toggleFieldChartType(sourceId, fieldId)}
            onToggleAnnotation={() => toggleFieldAnnotation(sourceId, fieldId)}
            onToggleSeparateAxis={() => toggleFieldSeparateAxis(sourceId, fieldId)}
        />
    );
});

export default FieldRow;
